export default {
  namespaced: true,
  state: {
    snackbar: {
      show: false,
      message: "",
      button: false,
    },
    user: {},
    token: "",
    roles: [],
    userStats: {
      blocked_tasks: 0,
      cancelled_tasks: 0,
      completed_tasks: 0,
      in_progress_tasks: 0,
      in_review_tasks: 0,
      overdue_tasks: 0,
      recurring_tasks: 0,
      todo_tasks: 0,
    },
    // User preferences
    preferences: {
      delayCompletedTasksLoad: false, // Default: load all tasks in one call
    },
    // Impersonation: when an admin takes over another user's account, we
    // stash the original admin's user/token here so we can restore them.
    impersonator: null, // { user, token } | null
  },
  mutations: {
    setMessage(state, v) {
      state.snackbar.show = v.show;
      state.snackbar.message = v.message;
      state.snackbar.button = v.button;
    },
    set_user(state, payload) {
      state.user = payload;
    },
    set_token(state, payload) {
      state.token = payload;
    },
    set_roles(state, payload) {
      state.roles = [...payload];
    },
    set_user_stats(state, payload) {
      state.userStats = { ...state.userStats, ...payload };
    },
    set_preferences(state, payload) {
      state.preferences = { ...state.preferences, ...payload };
    },
    set_impersonator(state, payload) {
      state.impersonator = payload;
    },
  },
  getters: {
    mSnackbar: (state) => state.snackbar,
    get_user: (state) => state.user,
    get_token: (state) => state.token,
    get_roles: (state) => state.roles,
    get_user_stats: (state) => state.userStats,
    get_preferences: (state) => state.preferences,
    get_impersonator: (state) => state.impersonator,
    is_impersonating: (state) => !!state.impersonator,
  },
  actions: {
    set_user({ commit }, payload) {
      commit("set_user", payload);
    },
    set_token({ commit }, payload) {
      commit("set_token", payload);
    },
    set_roles({ commit }, payload) {
      commit("set_roles", payload);
    },
    set_user_stats({ commit }, payload) {
      commit("set_user_stats", payload);
    },
    set_preferences({ commit }, payload) {
      commit("set_preferences", payload);
    },
    set_impersonator({ commit }, payload) {
      commit("set_impersonator", payload);
    },
  },
};
